import React from 'react';
import { useTranslation } from 'react-i18next';
import { Regions } from '../../hooks/useConfiguration';

export const Registration: React.FC<{
  region: Regions;
}> = ({ region }) => {
  const { t: tRegion } = useTranslation(region);
  const { t } = useTranslation();

  return (
    <>
      <h3>{t('privacy.registration.title')}</h3>
      <p>{t('privacy.registration.paragraph_1', { companyName: tRegion('contactData.companyName') })}</p>
      <p>{t('privacy.registration.paragraph_2')}</p>
      <p>{t('privacy.registration.paragraph_3')}</p>
    </>
  );
};
